






















import CategoryCard from "./_internal/CategoryCard.vue";
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import { CategoryCardsInterface } from "~/types";

export default {
  name: "CategoryCardGrid",
  components: { CategoryCard, SfHeading },
  props: {
    title: String,
    description: String,
    items: {
      type: Array as () => CategoryCardsInterface[],
      default: () => [],
    },
  },
  setup() {
    const getGridBackground = (item) => {
      return item?.background?.selectionValues[0]?.key || "var(--c-secondary)";
    };

    return {
      getGridBackground,
    };
  },
};
